import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AlertTriangle, Clock, Zap } from 'lucide-react'
import { useAuth } from '../auth'

// Popup "Licença não ativada" — SÓ para licenciado com licença pendente (preLicenciado).
// Aparece 10s após entrar; se o usuário clicar "Lembrar Depois", reaparece a cada 90s.
// Bloqueio PARCIAL: é um overlay dispensável (não trava a navegação permitida ao pré-licenciado).
export default function AvisoPagamentoPendente() {
  const { preLicenciado, user } = useAuth()
  const nav = useNavigate()
  const [aberto, setAberto] = useState(false)

  useEffect(() => {
    if (!preLicenciado) return
    let reTimer = null
    const primeiro = setTimeout(() => setAberto(true), 10000)   // 10s p/ 1ª exibição
    return () => { clearTimeout(primeiro); clearTimeout(reTimer) }
  }, [preLicenciado])

  if (!preLicenciado || !aberto) return null

  const lembrarDepois = () => {
    setAberto(false)
    setTimeout(() => setAberto(true), 90000)   // reaparece em 90s
  }

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 text-center space-y-4 tc-pop">
        <div className="w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center mx-auto">
          <AlertTriangle size={28} className="text-amber-500" />
        </div>
        <div>
          <h3 className="font-heading font-extrabold text-graphite text-lg">Licença não ativada</h3>
          <p className="text-sm text-gray-600 mt-1">
            {user?.nome ? `${String(user.nome).split(' ')[0]}, sua` : 'Sua'} licença ainda não foi ativada.
            Ative para liberar toda a plataforma — rede, comissões, vendas e materiais.
          </p>
        </div>
        <div className="space-y-2">
          <button onClick={() => { setAberto(false); nav('/dashboard') }}
            className="w-full rounded-xl bg-gradient-to-r from-primary-500 to-accent-500 text-white font-bold py-3 shadow-md flex items-center justify-center gap-2">
            <Zap size={16} /> Ativar minha licença
          </button>
          <button onClick={lembrarDepois}
            className="w-full rounded-xl border border-neutral-200 text-graphite font-semibold py-3 hover:bg-neutral-50 transition flex items-center justify-center gap-2">
            <Clock size={15} /> Lembrar Depois
          </button>
        </div>
      </div>
    </div>
  )
}
